import React from "react";

// Document grammar for the purchase-agreement page — numbered clauses, a
// register of label/value rows, and prose terms — backed by the ds-doc-*
// classes already defined in public.source.css. Presentational only.

export function Clause({ id, number, title, aside, children }) {
  return (
    <section id={id} aria-labelledby={`${id}-title`} className="ds-doc-clause" data-clause={number}>
      <div className="flex items-baseline justify-between gap-4">
        <h2 id={`${id}-title`} className="ds-doc-clause-title">
          <span className="ds-doc-clause-no">{number}.</span> {title}
        </h2>
        {aside}
      </div>
      {children}
    </section>
  );
}

export function Register({ children, className, label }) {
  return (
    <dl className={className ? `ds-doc-register ${className}` : "ds-doc-register"} aria-label={label}>
      {children}
    </dl>
  );
}

export function RegisterRow({ label, children, mono, wide, note, action, id, ...rest }) {
  return (
    <div id={id} className={`ds-doc-row${wide ? " ds-doc-row--wide" : ""}`} data-testid={rest["data-testid"]}>
      <dt className="ds-doc-row-label">{label}</dt>
      <dd className="ds-doc-row-value">
        <div className="ds-doc-row-line">
          <div className={`ds-doc-value min-w-0${mono ? " ds-doc-value--mono" : ""}`}>{children}</div>
          {action}
        </div>
        {note && <div className="ds-doc-row-note">{note}</div>}
      </dd>
    </div>
  );
}

export function Terms({ clause, items, className }) {
  return (
    <ol className={className ? `ds-doc-terms ${className}` : "ds-doc-terms"}>
      {items.map((item, i) => (
        <li key={i} className="ds-doc-term">
          <span className="ds-doc-term-no" aria-hidden="true">
            {clause}.{i + 1}
          </span>
          <span className="ds-doc-prose">{item}</span>
        </li>
      ))}
    </ol>
  );
}

const formatPersonalId = (value) => {
  const compact = String(value || "").replace(/[^0-9]/g, "");
  if (compact.length === 12) return `${compact.slice(0, 8)}-XXXX`;
  if (compact.length === 10) return `${compact.slice(0, 6)}-XXXX`;
  return value ? String(value).replace(/.{4}$/, "XXXX") : value;
};

export function Party({ t, roleKey, name, profile }) {
  const details = [
    profile?.bankIdSSN && formatPersonalId(profile.bankIdSSN),
  ].filter(Boolean);
  return (
    <div className="ds-doc-party" data-party={roleKey}>
      <p className="ds-doc-party-role">
        {t(`role.${roleKey}`)}
      </p>
      <p className="ds-doc-party-name">{name || "-"}</p>
      {details.length > 0 && (
        <p className="ds-doc-party-meta">
          {details.map((detail, index) => (
            <React.Fragment key={`${detail}:${index}`}>
              {index > 0 && <span aria-hidden="true"> · </span>}
              <span className={index === 0 && profile?.bankIdSSN ? "tabular-nums" : undefined}>{detail}</span>
            </React.Fragment>
          ))}
        </p>
      )}
    </div>
  );
}
